import React from 'react';

const ThreeDotsLoader = () => {
    return (
        <div className="loader">
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
        </div>
    );
};

export default ThreeDotsLoader;